import type { Project, ProjectInput, ProjectUpdate } from "@akhshy/types";
import { api } from "../lib/api.ts";
import { useResource } from "../lib/useResource.ts";
import { CrudPage } from "../components/organisms/CrudPage.tsx";
import { ProjectForm } from "../components/organisms/forms/ProjectForm.tsx";
import { Badge } from "../components/atoms/Badge.tsx";
import type { Column } from "../components/organisms/DataTable.tsx";

const columns: Column<Project>[] = [
  { header: "Name", render: (i) => <span className="cell-title">{i.name}</span> },
  { header: "Tag", render: (i) => <Badge tone="kind">{i.tag}</Badge> },
  { header: "Links", render: (i) => `${i.links.length}` },
];

export function ProjectsPage() {
  const resource = useResource<Project, ProjectInput, ProjectUpdate>(api.projects);
  return (
    <CrudPage
      intro="Things you've shipped — open source and otherwise."
      resource={resource}
      columns={columns}
      emptyText="no projects yet — add one from the tray."
      newLabel="New project"
      formTitle={(editing) => (editing ? "Edit project" : "New project")}
      itemLabel={(i) => i.name}
      renderForm={(p) => <ProjectForm {...p} resource={resource} />}
    />
  );
}
